import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Resume from "./pages/Resume";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";

export default function App() {
  return (
    <>
      <Navbar />

      <main>
        <section id="home" className="scroll-mt-20"><Home /></section>
        <section id="about" className="scroll-mt-20"><About /></section>
        <section id="resume" className="scroll-mt-20"><Resume /></section>
        <section id="portfolio" className="scroll-mt-20"><Portfolio /></section>
        <section id="contact" className="scroll-mt-20"><Contact /></section>
      </main>

      <Footer />
    </>
  );
}
